import { OrganGroup } from "./organ-group";

export class Organ {
  id: string;
  name: string;
  organ_group_id: string;
  organ_group: OrganGroup;

  static fieldsToMap = {
    direct: [
      'id',
      'organ_group_id',
      'name'
    ]
  }

  static buildFromAPI(record: any): Organ {
    const organ = new Organ();
    record = record || {};

    Organ.fieldsToMap.direct.forEach((k) => {
      organ[k] = record[k];
    });

    organ.organ_group = OrganGroup.buildFromAPI(record.organ_group)
    
    return organ;
  }
}